export default __webpack_public_path__ + "static/media/checked-blue.85e71f4b.svg";